import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/app/providers.tsx");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/styles/Global.css");
;
import(/* webpackMode: "eager" */ "/Users/batuhanmacbookairm3/Desktop/sunger-e-ticaret/src/styles/Product.css");
